import React from 'react';
import HelpdeskInfoComponent from 'shared/components/HelpdeskInfo';
import StationaryCombustionFields from './StationaryCombustionFields';
import MobileSourcesFields from './MobileSourcesFields';
import ProcessSourcesFields from './ProcessSourcesFields';
import FugitiveEmissionsFields from './FugitiveEmissionsFields';
import styles from '../activityDataEntry.module.scss';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { BestFitRegion } from 'models/BestFitRegion/bestFitRegion.model';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { CategoryOptions } from 'shared/utils/convertOptions';

interface ScopeOneCategoryFieldsProps {
  stationaryCombustion: HelpDeskInputFieldEnum;
  mobileSources: HelpDeskInputFieldEnum;
  processSources: HelpDeskInputFieldEnum;
  refrigirentKey: HelpDeskInputFieldEnum;
  handleToolTipOpen: (fieldName?: HelpDeskInputFieldEnum) => () => void;
  isEditView: boolean;
  handleMonthlyModalOpen: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string,
    selectedItemIndex?: number
  ) => () => void;
  handleSwitch: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string,
    selectedItemIndex?: number
  ) => () => void;
  refrigerantOptions: CategoryOptions[];
  fetchIngredientOrigin: (params?: {
    activity_label?: string;
  }) => Promise<BestFitRegion[] | undefined>;
}

const ScopeOneCategoryFields: React.FC<ScopeOneCategoryFieldsProps> = ({
  stationaryCombustion,
  mobileSources,
  processSources,
  refrigirentKey,
  handleToolTipOpen,
  isEditView,
  handleMonthlyModalOpen,
  handleSwitch,
  refrigerantOptions,
  fetchIngredientOrigin,
}) => {
  return (
    <div className={styles.categoryContainer}>
      <p className={styles.stationaryCategoryTitle}>
        Stationary Combustion
        <HelpdeskInfoComponent
          fieldKey={stationaryCombustion}
          className={styles.infoIcon}
        />
      </p>
      <StationaryCombustionFields
        handleToolTipOpen={handleToolTipOpen}
        isEditView={isEditView}
        handleMonthlyModalOpen={handleMonthlyModalOpen}
        handleSwitch={handleSwitch}
      />
      <p className={styles.mobileSourceCategoryTitle}>
        Mobile Sources
        <HelpdeskInfoComponent
          fieldKey={mobileSources}
          className={styles.infoIcon}
        />
      </p>
      <MobileSourcesFields
        handleToolTipOpen={handleToolTipOpen}
        isEditView={isEditView}
        handleMonthlyModalOpen={handleMonthlyModalOpen}
        handleSwitch={handleSwitch}
      />
      <p className={styles.mobileSourceCategoryTitle}>
        Process Sources
        <HelpdeskInfoComponent
          fieldKey={processSources}
          className={styles.infoIcon}
        />
      </p>
      <ProcessSourcesFields
        handleToolTipOpen={handleToolTipOpen}
        isEditView={isEditView}
        handleMonthlyModalOpen={handleMonthlyModalOpen}
        handleSwitch={handleSwitch}
      />
      <p className={styles.mobileSourceCategoryTitle}>
        Fugitive Emissions
        <HelpdeskInfoComponent
          fieldKey={refrigirentKey}
          className={styles.infoIcon}
        />
      </p>
      <FugitiveEmissionsFields
        handleToolTipOpen={handleToolTipOpen}
        isEditView={isEditView}
        refrigerantOptions={refrigerantOptions}
        fetchIngredientOrigin={fetchIngredientOrigin}
        handleMonthlyModalOpen={handleMonthlyModalOpen}
        handleSwitch={handleSwitch}
      />
    </div>
  );
};

export default ScopeOneCategoryFields;
